import React from 'react'
import { Text } from "@fluentui/react-components";
import { useTranslation } from 'react-i18next';

const EmptyState: React.FC<{ styles: any }> = ({ styles }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyState}>
      <Text size={600} weight="semibold">
        {t("chat.emptyTitle")}
      </Text>
      <Text className={styles.helperText}>
        {t("chat.emptySubtitle")}
      </Text>
    </div>
  );
};

export default EmptyState;
